import { Box, CircularProgress } from "@mui/material";
import { captureException } from "@sentry/react";
import { useAtomValue } from "jotai";
import type { FC, PropsWithChildren } from "react";
import { ErrorBoundary, type ErrorBoundaryProps } from "react-error-boundary";
import { RightsProvider } from "web_myplann/Api/Rights/RightsProvider";
import { ApplicationErrorPage } from "web_myplann/Infrastructure/Pages/ApplicationErrorPage";
import { useNavigateBack } from "./Hooks/useNavigateBack";
import { apiInitializedAtom } from "./State/apiInitializedAtom";

const reportRenderError: ErrorBoundaryProps["onError"] = (error, info) => {
	console.error(error, info.componentStack);
	captureException(error, (scope) => {
		scope.setExtra("componentStack", info.componentStack);
		scope.setExtra("pathname", window.location.pathname);
		return scope;
	});
};

export const MyPlannAuthenticatedRoute: FC<PropsWithChildren> = ({
	children,
}) => {
	const isApiInitialized = useAtomValue(apiInitializedAtom);

	useNavigateBack();

	const notReady = !isApiInitialized;

	if (notReady) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				height="100vh"
				top={0}
				left={0}
			>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<ErrorBoundary
			FallbackComponent={ApplicationErrorPage}
			onError={reportRenderError}
		>
			<RightsProvider>{children}</RightsProvider>
		</ErrorBoundary>
	);
};
